import { IMPORTS_IN_PROGRESS_STORE } from '../store';
import type { ImportInProgressStatus } from '../types';

// Whether any import is running for the given project (blocks update/delete project).
export const useIsImportInProgressForProject = (projectId: string | undefined): ImportInProgressStatus =>
  IMPORTS_IN_PROGRESS_STORE((state) => {
    if (!projectId) {
      return { isImportInProgress: false, isImportStatusLoading: false };
    }

    return {
      isImportInProgress: Object.values(state.importsInProgress).some((item) => item.projectId === projectId),
      isImportStatusLoading: !state.loadedProjectIds[projectId]
    };
  });
